<template>
  <div class="businessAdd">
    <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <div class="page-section">
        <div class="header-handle-box">
          <h3 class="state">
            清算订单号： {{lDetail.order_number}}
            <span class="status">{{lDetail.order_state == 2 ? '已发起清算,等待销售商退货' : ''}}</span>
            <span class="status">{{lDetail.order_state == 5 ? '退货数量审核中' : ''}}</span>
            <span class="status">{{lDetail.order_state == 4 ? '退货数量审核被拒绝' : ''}}</span>
            <span class="status">{{lDetail.order_state == 3 ? '退货数量审核通过，进入清算付款阶段' : ''}}</span>
            <span class="status">{{lDetail.order_state == 6 ? '清算已完成' : ''}}</span>
          </h3>
        </div>

        <div class="basic-wrap clearfix">
          <div class="img-wrap">
            <el-image class="img" :src="lDetail.productMainImageFile" fit="cover" :preview-src-list="[lDetail.productMainImageFile]"></el-image>
          </div>
          <div class="basic-info">
            <el-row>
              <div class="line">
                <span class="lab">商品名称： </span>
                <span class="val tit">{{lDetail.item_name}}</span>
              </div>
              <div class="line">
                <span class="lab">商品款号： </span>
                <span class="val tit">{{lDetail.item_style_number}}</span>
              </div>
              <div class="line">
                <span class="lab">供应商： </span>
                <span class="val tit">{{lDetail.supplierName}}</span>
              </div>
              <div class="line">
                <span class="lab">销售商： </span>
                <span class="val tit">{{lDetail.dealerName}}</span>
              </div>
              <div class="line">
                <span class="lab">当前定价： </span>
                <span class="val tit">{{lDetail.item_order_price | tablePrice}} 元</span>
              </div>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="page-section" v-if="billList_apply.length > 0">
      <div class="cg-mod-title mgt-0">平台向销售商打款账单</div>
      <ul class="time-line">
        <li class="item" v-for="(item, index) in billList_apply" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="item-tit">
              <strong class="item-tit-strong">平台向销售商打款，第{{billList_apply.length - index}}个账单</strong>
              <span class="item-tit-during">（审核通过账单生成时间：{{item.order_submit_time}}）</span>  
              <el-button type="danger" class="cg-btn red-border mgl-16" v-if="item.remainAmount>0&&function_clearControl" @click="openPayApply(item)">上传给销售商打款凭证</el-button>
            </div>
            <div class="item-sum-data">
              <div >本次销售商申请总金额：{{item.order_bill_amount}} 元</div>
              <div v-if="item.amountToBeConfirmed>0">平台已支付未被确认金额：（等待销售商确认）：{{item.amountToBeConfirmed}}  元</div>
              <div v-if="item.remainAmount>0">平台还需支付总金额：<span class="red">{{item.remainAmount}} 元</span></div>
            </div>
            <div class="item-box">
              <ul class="sub-time-line">
                <template v-if="item.orderPaymentList">
                  <li class="sub-item" v-for="(child, pay_i) in item.orderPaymentList" :key="pay_i">
                    <div class="pdb-12">
                      <span class="title">
                        <span class="time">{{child.order_submit_time}}</span>
                        平台上传了付款凭证，支付了{{child.order_payment_amount}}元
                      </span>
                      <el-tag type="success" v-if="child.order_state == 'y'">销售商已确认收到</el-tag>
                      <el-tag type="danger" v-if="child.order_state == 'n'">销售商已驳回</el-tag>
                      <el-tag type="warning" v-if="child.order_state == 'p'">待销售商确认</el-tag>
                    </div>
                    <div class="pdb-12">
                     <template v-for="(img_ele, img_index) in child.imageFiles">
                        <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                          :preview-src-list="child.imageFiles"></el-image>
                      </template>

                      <span v-if="child.order_payment_memo" class="pay-info grey">
                        说明：{{child.order_payment_memo}}
                      </span>
                    </div>
                  </li>
                </template>

              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="page-section" v-if="applyLists.length > 0">
      <div class="cg-mod-title mgt-0">申请记录</div>
      <ul class="time-line">
        <li class="item" v-for="(item, index) in applyLists" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="item-tit">
              销售商第{{applyLists.length - index}}次申请 ({{item.request_submit_time}})
            </div>
            <div class="item-box">
              <div class="grey">
                <div style="display: inline-block;width: 200px;">申请金额：{{item.request_amount}} 元</div>
                <el-tag type="success" v-if="item.request_state == 'y'">平台已同意</el-tag>

                <el-tag type="info" v-if="item.request_state == 'n'">平台已驳回</el-tag>
                <span v-if="item.request_state == 'n'&&item.request_last_update_memo">(驳回理由：{{item.request_last_update_memo}})</span>
                <el-tag type="danger" v-if="item.request_state == 'p'">待平台审核</el-tag>
                <el-button type="danger" v-if="item.request_state == 'p'" @click="openApplyAuth(item)" v-show="function_clearControl">去审核</el-button>
                <br>
                申请备注：{{item.request_content}} <br>
                <template v-for="(img_ele, img_index) in item.imgArr">
                  <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover" :preview-src-list="item.imgArr"></el-image>
                </template>



              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 退货数量记录 -->
    <div class="page-section">
      <div class="cg-mod-title mgt-0">退货记录</div>
      <div class="basic-info mgt-24">
        <el-row>
          <el-col :span="12">
            <div class="line" v-for="(list,index) in returnLists" :key="index">
              <span class="val" style="margin-right: 20px;">{{list.order_submit_time}} 销售商发起 <em>{{list.return_quantity}}</em>
                件退货请求</span>
              <span v-if="list.order_state=='p'" class="red">等待供应商审核</span>
              <span v-if="list.order_state=='y'" class="blue">已同意</span>
              <span v-if="list.order_state=='n'" class="orange">被拒绝</span>
              <br>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="page-section" v-if="lDetail.order_state == 3 || lDetail.order_state == 6">
      <div class="cg-mod-title mgt-0">清算数据</div>
      <div class="basic-info mgt-24">
        <el-row>
          <el-col :span="24">
            <div class="line">
              <span class="lab">销售商还需支付总金额： </span>
              <span class="green">
                {{ billList_final.order_arrears_amount }} +
                {{billList_final.autoEstablish}} x {{lDetail.item_order_price | tablePrice}} x {{lDetail.supplier_rate}}%
                =
                {{ billList_final.dealerSumPay }}元
              </span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="line">
              <span class="val">供应商同意了销售商的{{billList_final.orderRefundQuantity}}件退货请求</span><br>
              <span class="val">本次清算，
                {{billList_final.liquidateDataInfo && billList_final.liquidateDataInfo.order_submit_time}}
                销售商发起了退货{{billList_final.orderRefundQuantity}}件，
                退货后自动核销：{{billList_final.autoEstablish}}件</span><br>
              <span class="val">退货前您还需提交发起支付金额：{{ billList_final.order_arrears_amount }} 元</span><br>
              <!-- <span class="val">需平台确认支付金额：? 元</span> -->
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="time-line-title" v-if="platform_billList_final.liquidateOrderPaymentList">
        <h4 class="time-line-title-h4">
          平台结款支付
          <el-button type="primary" size="small" style="margin-left: 16px" v-if="lDetail.order_state != 6&&function_clearControl" @click="openUploadSettle()" >上传款结凭证</el-button>
        </h4>
        <div class="time-line-title-sub">

          平台结款账单总额：{{platform_billList_final.sum_pay_amonut}}元，
          供应商已确认金额总计：{{platform_billList_final.order_pay_amount }}元，
          <span v-if="platform_billList_final.chargeBalance == 0">
            平台结款已完成
          </span>
          <span v-else>
            平台还需支付<span class="red">{{platform_billList_final.chargeBalance}}</span>元
          </span>
        </div>
      </div>
      <ul class="time-line" v-if="platform_billList_final.liquidateOrderPaymentList && platform_billList_final.liquidateOrderPaymentList.length > 0">
        <li class="item" v-for="(pay_ele, index) in platform_billList_final.liquidateOrderPaymentList" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="pdb-12">
              <span class="title">
                <span class="time">{{pay_ele.order_submit_time}}</span>
                平台上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
              </span>
              <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
              <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
              <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
            </div>
            <div class="pdb-12">
              <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover" :preview-src-list="pay_ele.imageFiles"></el-image>
              </template>
              <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">
                说明：{{pay_ele.order_transfer_memo}}
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="time-line-title" v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0">
        <h4 class="time-line-title-h4">销售商支付</h4>
        <div class="time-line-title-sub">
          当前平台已确认金额总计{{billList_final.order_pay_amount}}元， 还需支付{{billList_final.chargeBalance}}元
        </div>
      </div>
      <ul class="time-line" v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0">
        <li class="item" v-for="(pay_ele, index) in billList_final.liquidateOrderPaymentList" :key="index">
          <div class="item-tail"></div>
          <div class="item-node"></div>
          <div class="item-content">
            <div class="pdb-12">
              <span class="title">
                <span class="time">{{pay_ele.order_submit_time}}</span>
                销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
              </span>
              <el-tag type="success" v-if="pay_ele.order_state == 'y'">平台已确认</el-tag>
              <el-tag type="warning" v-if="pay_ele.order_state == 'p'">待平台确认</el-tag>
              <el-tag type="danger" v-if="pay_ele.order_state == 'n'">平台已拒绝</el-tag>
              <el-button type="primary" size="small" style="margin-left: 16px" v-if="lDetail.order_state != 6 && pay_ele.order_state == 'p'&&function_clearControl"
                @click="getBillPayDetail(billList_final, pay_ele)">确认付款凭证</el-button>
            </div>
            <div class="pdb-12">
              <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover" :preview-src-list="pay_ele.imageFiles"></el-image>
              </template>
              <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">
                说明：{{pay_ele.order_transfer_memo}}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>


    <div class="page-section">
      <div class="cg-mod-title mgt-0">清算清单</div>
      <div class="take-order-table clearing">
        <table class="table">
          <tr class="th">
            <th width>下单订单号</th>
            <th width>下单总数</th>
            <th width>
              核销对应
              <br />价格(元)
            </th>
            <th width>
              已核销
              <br />件数
            </th>
            <th width>
              未核销
              <br />件数
            </th>
            <th width>
              已出账单需<br />支付额(元)
            </th>
            <th width>
              平台已确认<br />金额(元)
            </th>
            <th width>已出账单欠款(元)</th>
          </tr>
          <tr v-for="(item, index) in lDetail.orderPurchaseList" :key="index">
            <td>{{item.order_number}}</td>
            <td>{{item.order_purchase_quantity}}</td>
            <td>{{item.item_order_price | tablePrice}}</td>
            <td>{{item.sumEstablishQuantity}}</td>
            <td>{{item.unEstablishQuantity}}</td>
            <td>{{item.needPay}}</td>
            <td>{{item.sumPay}}</td>
            <td>{{item.debtMoney}}</td>
          </tr>

        </table>
      </div>
    </div>
    <!-- 确认付款凭证 -->
    <el-dialog title="确认付款凭证" :visible.sync="supplierSurePayPop" width="800px" :close-on-click-modal="false">
      <div class="cg-dialog-body">
        <div class="line">清算订单号：<span class="black">{{lDetail.order_number}}</span></div>
        <div class="line pdb-20">商品款号：<span class="black">{{lDetail.item_style_number}}</span></div>


        <div class="line">本期账单累计已支付：<span class="black"> {{billPeriodPayDetail.order_pay_amount}}元</span></div>
        <div class="line pdb-20">本期需支付金额：<span class="red"> {{billPeriodPayDetail.chargeBalance}}元</span></div>

        <div class="line">本次销售商付款金额：<span class="black">{{billSinglePayDetail.order_payment_amount}}元</span></div>
        <div class="line">剩余欠款金额：<span class="red">{{ billSinglePayDetail.restPay }}元</span></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="platformSurePay('n')" v-show="function_clearControl">未收到{{billSinglePayDetail.order_payment_amount}}元，驳回要求重新提交</el-button>
        <el-button type="primary" @click="platformSurePay('y')"  v-show="function_clearControl">确认收到{{billSinglePayDetail.order_payment_amount}}元</el-button>
      </div>
    </el-dialog>

    <!-- 平台上传结款凭证 -->
    <el-dialog title="上传结款凭证" :visible.sync="uploadsettlePayPop" width="800px" :close-on-click-modal="false">
      <div class="cg-dialog-body">
        <div class="line">清算订单号：<span class="black">{{lDetail.order_number}}</span></div>
        <div class="line pdb-20">商品款号：<span class="black">{{lDetail.item_style_number}}</span></div>

        <div class="line pdb-20">本次付款明细账单：</div>
        <div class="line">本期账单总金额：<span class="black">{{platformPopShowData.sumAmount}}元</span></div>
        <div class="line">本期账单累计已支付：<span class="black">{{platformPopShowData.hadPaidAmount}}元（供应商已确认的支付金额）</span></div>
        <div class="line pdb-20">本期还需支付金额：<span class="red">{{platformPopShowData.restPayAmount}}元</span>（本周期总金额 -
          供应商已确认的支付金额）</div>

        <el-form ref="ruleForm" label-width="160px" :model="uploadsettleForm" :rules="uploadsettlerules">
          <el-form-item label="本次实际付款金额：" prop="amount">
            <el-input placeholder="请输入付款金额" style="width: 300px" :value="uploadsettleForm.amount" @input="inputPriceHandle"
              @blur="blurPriceHandle"></el-input>
          </el-form-item>
          <el-form-item label="上传结款凭证：">
            <div>
              <el-upload :action="uploadFileApi" name="files" list-type="picture-card" :file-list="uploadsettleImgsList"
                :multiple="false" :data="uploadData" :on-remove="handleRemove" :before-upload="beforeUpload"
                :on-success="onSuccess" :on-error="onError" accept="image/*">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="付款说明：">
            <el-input type="textarea" placeholder="请输入说明，最多300个字" v-model="uploadsettleForm.memo"></el-input>
          </el-form-item>
        </el-form>

      </div>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadsettlePayPop = false"  v-show="function_clearControl">取 消</el-button>
        <el-button type="primary" @click="uploadsettleSubmit"  v-show="function_clearControl">确 定</el-button>
      </div>
    </el-dialog>
    <applyAuth :isLiquidation="true" v-show="isShowApplyAuthModal" :info="currentApplyAuthObj" @close="closeApplyAuthModal" @success="closeApplyAuthModalAndSuccess">  </applyAuth>
    <applypay :isLiquidation="true" v-show="isShowPayApplyModal" :info="currentPayApplyObj" @close="closeApplyPayModal" @success="closeApplyPayModalAndSuccess">  </applypay>

  </div>
</template>

<script>
  import {
    json,
    wordData,
    utils
  } from "@/common/common.js";
  import {
    ajaxPost,
    api
  } from "@/common/request.js";
  import {
    lockOrderState
  } from "@/common/order-state.js";
  import {
    accMul,
    validatePrice
  } from "@/common/tool.js";
  import applyAuth from "@/components/applyAuth";
  import applypay from "@/components/paymodal_apply.vue";
  export default {
    data() {
      var validatePriceFn = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入金额'))
        } else if (!validatePrice(value)) {
          callback(new Error('金额格式不正确'))
        } else {
          callback();
        }
      }
      return {
        isLoading: false,
        returnLists: [], //退货明细

        lDetail: {
          dealerName: '',
          dealer_user_id: '',
          itemFeeSplitting: '',
          supplier_rate: "",
          dealer_rate: "",
          item_id: '',
          item_name: '',
          item_order_price: '',
          item_style_number: '',
          orderPurchaseList: [],
          order_id: '',
          order_number: '',
          order_state: '',
          productMainImageFile: '',
          supplierName: '',
          supplier_user_id: '',
        },

        // 清算相关数据
        liquidateDataInfo: '',
        liquidateDataInfo_data: '',

        // 确认退货数量弹框
        confirmReturnGoodsPop: false,
        returnGoodsList: [],
        currentReturnGoods: {},

        // 确认销售商付款
        supplierSurePayPop: false,
        billList_final_list: [],
        billList_final: {},
        billPeriodPayDetail: {},
        billSinglePayDetail: {},

        // 平台结款
        platformUploadPayPop: false,
        platform_billList_final_list: [],
        platform_billList_final: {},
        platform_billPeriodPayDetail: {},
        platform_billSinglePayDetail: {},

        // 上传结款凭证 弹框
        uploadsettlePayPop: false,
        uploadFileApi: api.baseUrl + '/file/uploadfilebatch',
        uploadData: {
          imageType: 12301,
          imageUserId: ''
        },
        platformPopShowData: {},
        uploadsettleImgsList: [],
        uploadsettleForm: {
          amount: '',
          memo: ''
        },
        uploadsettlerules: {
          amount: [{
              required: true,
              message: '请输入金额',
              trigger: 'blur'
            },
            {
              validator: validatePriceFn,
              trigger: 'blur'
            }
          ],
        },

        applyLists: [],
        isShowApplyAuthModal: false,
        currentApplyAuthObj: {},

        billList_apply: [],
        isShowPayApplyModal:false,
        currentPayApplyObj:{}
      }
    },
    components: {
      applyAuth,applypay
    },
    computed: {
      IMG_PREV() {
        return api.imgPrev;
      },
      adminId() {
        return utils.getAdminId()
      },
      function_lockView() {
        return utils.getCurrentFunction().indexOf("lockView")>-1
      },
      function_lockControl() {
        return utils.getCurrentFunction().indexOf("lockControl")>-1
      },
      function_orderView() {
        return utils.getCurrentFunction().indexOf("orderView")>-1
      },
      function_orderControl() {
        return utils.getCurrentFunction().indexOf("orderControl")>-1
      },
      function_clearView() {
        return utils.getCurrentFunction().indexOf("clearView")>-1
      },
      function_clearControl() {
        return utils.getCurrentFunction().indexOf("clearControl")>-1
      },
    },
    created() {
      this.uploadData.imageUserId = this.adminId
      this.initPage()

      // this.getDwLiquidateEstablishInfoByOid()
    },
    methods: {
      initPage() {
        this.getLiquidationDetail()
        this.getReturnGoodInfo()
      },
      openPayApply(list){
        console.log(list)
        this.isShowPayApplyModal=true
        // this.currentPayApplyObj=list
        this.currentPayApplyObj={
          liquidateOrderId:list.parent_order_id,
          supplierUserId: list.supplier_user_id,
          dealerUserId: list.dealer_user_id,
          itemId: list.ces,
          billOrderId:list.order_id,
          maxNumber:list.remainAmount
        }
      },
      closeApplyPayModal() {
        this.isShowPayApplyModal = false
      },
      closeApplyPayModalAndSuccess() {
        this.isShowPayApplyModal = false
        this.getLiquidationDetail();
      },
      openApplyAuth(list) {
        console.log(list)
        this.isShowApplyAuthModal = true
        this.currentApplyAuthObj = list
      },
      closeApplyAuthModal() {
        this.isShowApplyAuthModal = false
      },
      closeApplyAuthModalAndSuccess() {
        this.isShowApplyAuthModal = false
        this.getLiquidationDetail();
      },
      getApplyList() {
        let _this = this
        this.applyLists = []
        ajaxPost("dwOrder/applicationList", {
          liquidateOrderId: this.$route.query.orderId
        }).then(res => {
          if (res.errorCode == 200) {
            this.applyLists = res.data.map(function(item, index) {
              console.log(item)
              item.imgArr = item.image_file ? item.image_file.split(',').map(ele => ele ? _this.IMG_PREV + ele :
                '') : []
              return item
            })

          } else {
            this.$message.error(res.errorMsg)
          }
        })
      },
      // 获取退货数量信息
      getReturnGoodInfo() {
        ajaxPost("/dwOrder/returnGoodInfo", {
          liquidateOrderId: this.$route.query.orderId
        }).then(res => {
          console.log(res,'获取退货数接口返回，returnGoodInfo')
          if (res.errorCode == 200) {
            this.returnLists = res.data
          } else {
            this.returnLists = []
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 获取清算详情
      getLiquidationDetail() {
        this.isLoading = true;
        ajaxPost("/dwOrder/liquidateInfo", {
          liquidateOrderId: this.$route.query.orderId
        }).then(res => {
          console.log(res,'获取清算详情接口返回')
          this.isLoading = false;
          if (res.errorCode == 200) {
            this.lDetail = res.data[0];
            this.lDetail.productMainImageFile = this.lDetail.productMainImageFile ? this.IMG_PREV + this.lDetail.productMainImageFile :
              ''
            this.lDetail.supplier_rate = this.lDetail.itemFeeSplitting ?
              accMul(this.lDetail.itemFeeSplitting.split(",")[1], 100) :
              "";
            this.lDetail.dealer_rate = this.lDetail.itemFeeSplitting ?
              accMul(this.lDetail.itemFeeSplitting.split(",")[0], 100) :
              "";

            if (this.lDetail.liquidateDataInfo) {
              this.liquidateDataInfo = this.lDetail.liquidateDataInfo;
              this.liquidateDataInfo_data = JSON.parse(
                this.liquidateDataInfo.order_content
              );
            } else {
              this.liquidateDataInfo = "";
              this.liquidateDataInfo_data = "";
            }

            if (this.lDetail.orderPurchaseList) {
              this.lDetail.orderPurchaseList = this.lDetail.orderPurchaseList.map(item => {
                // 欠款
                let debtMoney = utils.computeSub(item.needPay - item.sumPay)
                // 核销数 ，未核销数
                let sumEstablishQuantity, unEstablishQuantity
                if (item.sumEstablishQuantity == undefined || item.sumEstablishQuantity === '') {
                    sumEstablishQuantity = '/'
                    unEstablishQuantity = '/'
                } else {
                    sumEstablishQuantity = item.sumEstablishQuantity
                    unEstablishQuantity = item.order_purchase_quantity - item.sumEstablishQuantity
                }
                return {
                  ...item,
                  debtMoney,
                  sumEstablishQuantity,
                  unEstablishQuantity
                }

              })
            }



            this.getBillList(3)
            this.getBillList(4)
            this.getBillList(6)
            this.getApplyList()
          }
        }).catch(err => {
          this.isLoading = false;
          console.log(err)
        })
      },
      // 获取退货数量信息
      returnGoodInfo() {
        ajaxPost("/dwOrder/returnGoodInfo", {
          liquidateOrderId: this.$route.query.orderId,
        }).then(res => {
          console.log(res,'退货数量接口返回')
          if (res.errorCode == 200) {
            this.returnGoodsList = res.data
            this.currentReturnGoods = res.data[0]
          } else {

          }
        }).catch(err => {
          console.log(err)
        })
      },

      // 获取账单信息  1 - 销售商  2 - 平台  3 - 清算账单
      getBillList(billType) {
        ajaxPost("/dwOrder/getBillList", {
          billType: billType,
          orderPurchaseNumber: '',
          liquidateOrderId: this.lDetail.order_id
        }).then(res => {
          console.log(res,'获取账单接口返回');
          if (res.errorCode == 200) {
            if (billType == 3) {
              this.billList_final_list = res.data.map(element => {
                // let order_content = JSON.parse(element.liquidateOrderPaymentList.order_content)
                let chargeBalance = element.chargeBalance ?
                  (+element.chargeBalance > 0 ? +element.chargeBalance : 0).toFixed(2) :
                  (element.order_arrears_amount + element.order_bill_amount).toFixed(2)
                let order_content = {}
                try {
                  order_content = JSON.parse(this.liquidateDataInfo.order_content)
                } catch (error) {

                }
                return {
                  ...element,
                  order_arrears_amount: (+element.order_arrears_amount).toFixed(2),
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  dealerSumPay: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                  autoEstablish: order_content.autoEstablish,
                  sumOrderQuantity: order_content.sumOrderQuantity,
                  sumOrderEstablish: order_content.sumOrderEstablish,
                  orderRefundQuantity: order_content.orderRefundQuantity,
                  order_pay_amount: (+element.order_pay_amount).toFixed(2),
                  chargeBalance: chargeBalance,
                  liquidateOrderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList
                    .map(item => {
                      return {
                        ...item,
                        imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                          ele : '') : [],
                        restPay: (chargeBalance - item.order_payment_amount > 0 ? chargeBalance - item.order_payment_amount :
                          0).toFixed(2),
                      }
                    }) : []
                }
              });
              this.billList_final = this.billList_final_list[0] || {}
            }

            if (billType == 4) {
              this.platform_billList_final_list = res.data.map(element => {
                // let order_content = JSON.parse(element.liquidateDataInfo.order_content)
                return {
                  ...element,
                  order_arrears_amount: (+element.order_arrears_amount).toFixed(2),
                  order_bill_amount: (+element.order_bill_amount).toFixed(2),
                  dealerSumPay: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                  // autoEstablish: order_content.autoEstablish,
                  // sumOrderQuantity: order_content.sumOrderQuantity,
                  // sumOrderEstablish: order_content.sumOrderEstablish,
                  // orderRefundQuantity: order_content.orderRefundQuantity,
                  order_pay_amount: (+element.order_pay_amount).toFixed(2),
                  sum_pay_amonut: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                  chargeBalance: element.chargeBalance ?
                    (+element.chargeBalance > 0 ? +element.chargeBalance : 0).toFixed(2) : (element.order_arrears_amount +
                      element.order_bill_amount).toFixed(2),
                  liquidateOrderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList
                    .map(item => {
                      return {
                        ...item,
                        imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                          ele : '') : [],
                        restPay: (element.chargeBalance - item.order_payment_amount > 0 ? element.chargeBalance -
                          item.order_payment_amount : 0).toFixed(2),
                      }
                    }) : []
                }
              });
              this.platform_billList_final = this.platform_billList_final_list[0] || {}
            }
            if(billType==6){
              this.billList_apply = res.data.map(element => {
                return {
                  ...element,
                  orderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList.map(item => {
                    return {
                      ...item,
                      imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV +
                        ele : '') : []
                    }
                  }) : []
                }
              });
            }


          } else {

          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 获取当前账单
      getBillPayDetail(item, pay_ele) {
        this.billPeriodPayDetail = item
        this.billSinglePayDetail = pay_ele
        this.supplierSurePayPop = true
      },
      // 确认销售商付款
      platformSurePay(state) {
        ajaxPost("/dwOrder/confirmOrderPaymentByliquidate", {
          "liquidatePaymentNumber": this.billSinglePayDetail.order_number,
          "dwLiquidatePaymentState": state,
          "liquidatePaymentNumberByBill": this.billPeriodPayDetail.order_number,
          "liquidateOrderId": this.lDetail.order_id,
          "billId": this.billPeriodPayDetail.order_id,
        }).then(res => {
          console.log(res);
          if (res.errorCode == 200) {
            this.supplierSurePayPop = false
            this.$message.success('操作成功')
            this.getBillList(3)
            this.getBillList(4)
          } else {
            this.$message.error(res.errorMsg || '操作失败')
          }
        }).catch(err => {
          console.log(err)
        })
      },

      // 平台上传结算凭证
      openUploadSettle() {
        this.platformPopShowData = {
          sumAmount: this.platform_billList_final.sum_pay_amonut,
          hadPaidAmount: this.platform_billList_final.order_pay_amount,
          restPayAmount: (this.platform_billList_final.sum_pay_amonut - this.platform_billList_final.order_pay_amount)
            .toFixed(2),
        }

        this.uploadsettleImgsList = [];
        this.uploadsettleForm.amount = '';
        this.uploadsettleForm.memo = '';

        this.uploadsettlePayPop = true
      },
      inputPriceHandle(e) {
        const reg = /((^\s{0}|^\d*))(\.\d*){0,1}$/
        if (reg.test(e)) {
          this.uploadsettleForm.amount = e
        }
      },
      blurPriceHandle() {
        if (this.uploadsettleForm.amount != '') {
          let val = parseFloat(this.uploadsettleForm.amount);
          this.uploadsettleForm.amount = val.toFixed(2);
        }
      },
      // 上传图片
      beforeUpload(file) {
        console.log('beforeUpload', file)
        if (!(file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')) {
          this.$message({
            type: 'warning',
            message: '必须为图片且要求是.png或.jpg格式!'
          })
          return false
        } else if (file.size > 10 * 1024 * 1024) {
          this.$message({
            type: 'warning',
            message: '图片大小不能超过10M!'
          })
          return false
        }
      },
      onSuccess(response, file, fileList) {
        console.log('onSuccess', response, file, fileList)
        this.uploadsettleImgsList = fileList
      },
      onError(err, file, fileList) {
        console.log('onError', err, file, fileList)
        this.$message({
          type: 'error',
          message: '图片上传失败!'
        })
      },
      // 图片删除
      handleRemove(file, fileList) {
        console.log(file, fileList)
        this.uploadsettleImgsList = fileList
      },
      uploadsettleSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            console.log('this.uploadsettleForm', this.uploadsettleForm)
            console.log('this.uploadsettleImgsList', this.uploadsettleImgsList)
            let ImgsList = this.uploadsettleImgsList.map(item => {
              return {
                imageFiles: item.response.data.imageFiles,
                imgId: item.response.data.imgId
              }
            })
            let ImgsListStr = JSON.stringify(ImgsList)
            ajaxPost("/dwOrder/saveLiquidatePayment", {

              "supplierUserId": this.lDetail.supplier_user_id,
              "dealerUserId": this.lDetail.dealer_user_id,
              "liquidateOrderId": this.lDetail.order_id,
              "itemId": this.lDetail.item_id,
              "imgJson": ImgsListStr,
              "liquidateBillOrderId": this.platform_billList_final.order_id,
              "orderLiquidateAmount": this.uploadsettleForm.amount,
              "orderLiquidateMemo": this.uploadsettleForm.memo,
              "adminId": this.adminId
            }).then(res => {
              console.log(res)
              if (res.errorCode == 200) {
                this.uploadsettlePayPop = false
                this.$message.success(res.errorMsg || '操作成功')
                this.getBillList(3)
                this.getBillList(4)
              } else {
                this.$message.error(res.errorMsg || '操作失败')
              }
            }).catch(err => {
              console.log(err)
            })
          }
        })
      },

    }
  };
</script>

<style scoped lang="scss">
  .page-section {
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 16px;
  }

  .header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 40px 80px;

    .state {
      font-size: 20px;
      color: #333;
      font-weight: 500;

      &.red {
        color: #F81D22;
      }
    }

    .status {
      color: #F81D22;
      margin-left: 10px;
      font-size: 16px;
    }

    .btns {
      margin-top: 40px;

      .cg-btn {
        margin-right: 20px;
      }
    }

    .tip {
      margin-top: 14px;
      height: 20px;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      line-height: 20px;
    }

    .tip-small {
      margin-left: 8px;
      height: 20px;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      font-size: normal;
      line-height: 20px;
    }
  }

  .basic-info {
    &.mgt-24 {
      margin-top: 24px;
    }

    &.mgt-40 {
      margin-top: 40px;
    }

    .line {
      padding-bottom: 16px;
      font-size: 14px;
      line-height: 22px;

      .lab {
        color: rgba(0, 0, 0, 0.85);
      }

      .val {
        color: rgba(0, 0, 0, 0.65);
      }

      &.blue .lab,
      &.blue .val {
        color: #1890FF
      }

      .green {
        color: #52C41A;
      }

      .text-btn {
        margin-left: 16px;
        background: transparent;
        border: none;
        font-size: 14px;
        color: #1890FF;
        outline: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .basic-wrap {
    margin-top: 24px;
    padding: 24px;
    border: 1px solid rgba(0, 0, 0, 0.06);

    .img-wrap {
      float: left;
      width: 100px;
      height: 100px;
      border: 1px solid #f0f0f0;

      .img {
        width: 100px;
        height: 100px;
      }
    }

    .basic-info {
      padding-left: 136px;

      .line {
        padding-bottom: 16px;
        font-size: 14px;
        line-height: 22px;

        .lab {
          color: rgba(0, 0, 0, 0.85);
        }

        .val {
          color: rgba(0, 0, 0, 0.65);

          &.tit {
            display: inline-block;
            vertical-align: top;
            width: 720px;
          }
        }
      }
    }
  }

  .take-order-table {
    &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
    }

    .table {
      border: 1px solid #E6E6E6;
      width: 100%;
      min-width: 980px;
      border-spacing: 0;
      border-collapse: collapse;
      font-size: 14px;

      tr {
        height: 50px;
      }

      tr.th {
        background: #fafafa;
      }

      tr th {
        color: rgba(0, 0, 0, 0.85);
        font-weight: normal;
      }

      td {
        border: 1px solid #E6E6E6;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
      }

      &.min-400 {
        min-width: 400px;
      }
    }

    &.mgt-24 {
      margin-top: 24px;
    }

    &.clearing {
      margin-top: 24px;
    }

    &.clearing tr th {
      border: 1px solid #E6E6E6;
    }

    &.clearing tr th:last-child,
    &.clearing tr td:last-child {
      color: #F81D22;
    }

  }

  .gap-line {
    margin: 40px 0;
    height: 1px;
    background: #E6E6E6;
  }

  .time-line-title {
    margin-top: 16px;

    .time-line-title-h4 {
      font-size: 14px;
      font-weight: 500;
    }

    .time-line-title-sub {
      font-size: 13px;
    }
  }



  .time-line {
    margin-top: 24px;
    list-style: none;

    .item {
      position: relative;

      .item-tail {
        position: absolute;
        top: 10px;
        left: 4px;
        width: 2px;
        height: 100%;
        background: #F7F7F7;
      }

      .item-node {
        position: absolute;
        top: 10px;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #D9D9D9;
      }

      &:first-child .item-node {
        background: #2A2E3F
      }

      &:last-child .item-tail {
        width: 0;
      }

      .item-content {
        padding-left: 32px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
        padding-bottom: 16px;
      }

      .item-tit {
        padding-bottom: 8px;
      }

      .item-box {
        background: rgba(0, 0, 0, 0.02);
        border-radius: 2px;
        padding: 24px;

        .pdb-12 {
          padding-bottom: 12px;
        }

        .pdb-6 {
          padding-bottom: 6px;
        }

        .grey {
          color: rgba(0, 0, 0, 0.45);
        }

        .green {
          color: #52C41A
        }

        .blue {
          color: #1890FF
        }
      }

      .title {
        display: inline-block;
        width: 450px;
      }

      .time {
        font-size: 13px;
        color: #000;
        margin-right: 6px;
      }

      .img {
        width: 100px;
        height: 100px;
        border: 1px solid #eee;
        vertical-align: top;
      }
    }

    .sub-time-line {
      list-style: none;

      .sub-item {
        position: relative;
        padding-left: 24px;

        &::before {
          content: ' ';
          position: absolute;
          top: 15px;
          left: 3px;
          width: 1px;
          height: calc(100% - 12px);
          background: #D8D8D8;
        }

        &::after {
          content: ' ';
          position: absolute;
          top: 6px;
          left: 0;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #fff;
          border: 1px solid #D8D8D8;
          box-sizing: border-box;
        }

        &:first-child::after {
          background: #FF9C6E;
          border: 1px solid #FF9C6E;
        }

        &:last-child::before {
          width: 0;
        }
      }
    }

  }

  .address-wrap {
    padding-top: 16px;
  }

  .address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
  }

  .address-content {
    padding: 6px 0px;
    color: #333;
    font-size: 13px;

    .line {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .gap {
      margin-left: 30px;
    }
  }

  .cg-dialog-body {
    padding: 24px;

    .line {
      font-size: 14px;
      line-height: 2;
      color: #555;

      .black {
        color: #111;
      }

      .red {
        color: #F81D22;
      }

      &.pdb-20 {
        padding-bottom: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/detail-clear.vue